export const colors = {
  primaryColor : "#48e6e6",
  secondaryColor : "#080808",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(108deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 36.65%, rgba(72, 230, 230, 0.60) 78.17%, rgba(72, 230, 230, 0.60) 124.19%)",
darkColor:"#3dc1c1"
}